import Vue from "vue";
// const EventBus = new Vue()
// Vue.prototype.$EventBus = new Vue()

// const heartCheck = {
//   timeout: 10000, // 1分钟发一次心跳
//   timeoutObj: null,
//   //   serverTimeoutObj: null,
//   reset: function () {
//     clearInterval(this.timeoutObj)
//     // clearTimeout(this.serverTimeoutObj)
//     return this
//   },
//   start: function () {
//     // var self = this
//     this.timeoutObj = setInterval(function () {
//       // 这里发送一个心跳，后端收到后，返回一个心跳消息，
//       // onmessage拿到返回的心跳就说明连接正常
//       if (window.lessonWS && window.lessonWS.ws) {
//         window.lessonWS.ws.send('ping')
//       }
//       console.log('ping!')
//       //   self.serverTimeoutObj = setTimeout(function () { // 如果超过一定时间还没重置，说明后端主动断开了
//       //     if (window.lessonWS) window.lessonWS.close() // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
//       //   }, self.timeout)
//     }, this.timeout)
//   }
// }

export function openWS(
  {
    token = "",
    company_id = "",
    user_id = "",
    login_name = "",
    from_open = "",
    sys_id = localStorage._sys_id || 5,
    trainplan_id = "",
    resources_id = "",
    scorm_id = 0,
    chapter_id = 0,
  },
  callback = null
) {
  // 开启ws
  // console.log('开启ws', scorm_id, chapter_id)
  if (!(window.lessonWS && window.lessonWS.ws)) {
    // console.log('进入了openWS')
    window.lessonWS = {};
    let WS_PATH = null;
    // if (process.env.VUE_APP_MODE === "local") {
    if (
      location.origin.indexOf(".el.net") != -1 ||
      process.env.VUE_APP_MODE === "local"
    ) {
      //   WS_PATH = "ws://192.168.20.240:9502"
      WS_PATH = "wss://websocket.test.eceibs.com.cn";
    } else if (location.origin.indexOf(".test.eceibs.com.cn") != -1) {
      WS_PATH = "wss://websocket.test.eceibs.com.cn"; // 测试
    } else if (location.origin.indexOf(".test2.eceibs.com.cn") != -1) {
      WS_PATH = "wss://websocket.test2.eceibs.com.cn"; // 测试2
    } else {
      WS_PATH = "wss://websocket.eceibs.net";
    }
    window.lessonWS.id = "";
    var wsUrl = `${WS_PATH}/lesson?token=${token}&company_id=${company_id}&user_id=${user_id}&login_name=${login_name}&from_open=${from_open}&sys_id=${sys_id}&trainplan_id=${trainplan_id}&resources_id=${resources_id}&scorm_id=${scorm_id}&chapter_id=${chapter_id}&no_timer=1`;
    createWebSocket(wsUrl, callback);
  } else {
    window.lessonWSOnOpen();
  }
}
function createWebSocket(wsUrl, callback = null) {
  try {
    if ("WebSocket" in window) {
      window.lessonWS.ws = new WebSocket(wsUrl);
      initEventHandle(callback);
    } else {
      alert("您的浏览器版本不支持部分功能，请升级浏览器!");
    }
  } catch (e) {
    // TODO 首次open失败，再重连下
    reconnect();
  }
}

// 页面切换至前台时连接socket
export function pageShowToConnect(wsUrl) {
  window.lessonWS = {};
  createWebSocket(wsUrl);
}

// 页面切到后台时获取websocket的url
export function pageHiddenToGetWSUrl() {
  let ws = window.lessonWS.ws;
  if (
    ws &&
    (ws.readyState == WebSocket.CONNECTING || ws.readyState == WebSocket.OPEN)
  ) {
    return ws.url;
  }
}

let alertNum = 1;
function initEventHandle(callback) {
  window.lessonWS.ws.onclose = function (event) {
    // console.log('关闭ws---lockReconnect是true正确', this.lockReconnect)
    reconnect(); // 重连
    if (window.lessonWS && window.lessonWS.timeoutObj) {
      clearInterval(window.lessonWS.timeoutObj);
      window.lessonWS.timeoutObj = null;
    }
    if (window.lessonWSOnclose) {
      window.lessonWSOnclose(event);
    }
    // window.lessonWS = null;
  };
  window.lessonWS.ws.onopen = function () {
    // window.lessonWS.ws.send('zanting', {})
    // TODO 心跳检测重置
    // console.log('心跳检测重置')
    if (window.lessonWS && window.lessonWS.timeoutObj) {
      clearInterval(window.lessonWS.timeoutObj);
      window.lessonWS.timeoutObj = null;
    }
    window.lessonWS.timeoutObj = setInterval(function () {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息，
      // onmessage拿到返回的心跳就说明连接正常
      if (window.lessonWS && window.lessonWS.ws) {
        // console.log('ping!')
        window.lessonWS.ws.send("ping");
      }
      //   self.serverTimeoutObj = setTimeout(function () { // 如果超过一定时间还没重置，说明后端主动断开了
      //     if (window.lessonWS) window.lessonWS.close() // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
      //   }, self.timeout)
    }, 10000);

    // console.log('llws连接成功!' + new Date().toLocaleString())

    if (window.lessonWSOnOpen) {
      window.lessonWSOnOpen();
    }

    if (callback) {
      callback();
    }
    // 断连之后有学习时长的情况下
    // let str = _this.getStatisticDuration()
    // if (str) {
    //   // console.log('给websocket发送学习时间', str)
    //   _this.learningTimeWS.ws.send(str)
    //   localStorage.removeItem('duration')
    // }
  };
  window.lessonWS.ws.onmessage = function (event) {
    // 如果获取到消息，心跳检测重置
    // _this.heartCheck.reset().start() // 拿到任何消息都说明当前连接是正常的

    if (event.data != "pong") {
      let data = eval("(" + event.data + ")");
      if (data.code == 403 || data.code == 401) {
        if (window.location.href.indexOf("/login") != -1) {
          return false;
        }
        if (alertNum == 1) {
          alertNum++;
          let modalTip =
            data.code == 403
              ? "你正在学习课程，平台不支持同时打开多个课程学习页面"
              : "您已在其他地方登录，当前帐号已经退出。如果这不是你本人的操作，请注意安全。";
          //   Vue.prototype.$EventBus.$emit('modalTip', modalTip)
          Vue.prototype.$dialog({
            content: modalTip,
            leftBtn: {
              style: {
                display: "none",
              },
            },
            rightBtn: {
              style: {
                display: "none",
              },
            },
          });
        }
      }
    }

    if (window.lessonWSOnMessage) {
      window.lessonWSOnMessage(event);
    }
  };
}

// 主动关闭，lessonWS置空
export function closeWS() {
  if (window.lessonWS && window.lessonWS.ws) {
    clearInterval(window.lessonWS.timeoutObj);
    window.lessonWS.ws.close();
    window.lessonWS.timeoutObj = null;
    window.lessonWS.ws = null;
    window.lessonWS = null;
  }
}

// 重连
function reconnect() {
  if (!window.lessonWS) {
    return;
  }
  let ws = window.lessonWS.ws;
  if (!ws) {
    return;
  }
  if (
    ws.readyState == WebSocket.CONNECTING ||
    ws.readyState == WebSocket.OPEN
  ) {
    return;
  }
  setTimeout(function () {
    if (
      ws.readyState == WebSocket.CONNECTING ||
      ws.readyState == WebSocket.OPEN
    ) {
      return;
    }
    createWebSocket(ws.url);
    // _this.createWebSocket(url);
    // _this.lockReconnect = false;
  }, 2000);
}

// function reconnect (url) {
//   let _this = this
//   if (_this.lockReconnect) return
//   _this.lockReconnect = true

//   setTimeout(function () { // 没连接上会一直重连，设置延迟避免请求过多
//     console.log('重连中。。。', _this.reconnect_num)
//     if (_this.reconnect_num == 0) {
//       _this.sendLog('websocket_断开_')
//     }
//     _this.createWebSocket(url)
//     _this.lockReconnect = false
//     _this.reconnect_num++

//     if (_this.reconnect_num == 5) {
//       _this.showConfirm()
//       _this.sendLog('websocket_重连失败_')
//     }
//   }, 2000)
// }

export function openLearningTime() {
  if (
    window.lessonWS &&
    window.lessonWS.ws &&
    window.lessonWS.ws.readyState === 1
  ) {
    let json = {
      type: "openLearningTime",
    };
    let str = JSON.stringify(json);
    // console.log('openLearningTime---开始记录学习时长')
    window.lessonWS.ws.send(str);
  }
}
// 暂停记录学习时长
export function closeLearningTime() {
  if (
    window.lessonWS &&
    window.lessonWS.ws &&
    window.lessonWS.ws.readyState === 1
  ) {
    let json = {
      type: "closeLearningTime",
    };
    let str = JSON.stringify(json);
    // console.log('closeLearningTime---暂停记录学习时长')
    window.lessonWS.ws.send(str);
  }
}

// 统计入库学习时长
export function statisticDuration() {
  if (window.lessonWS && window.lessonWS.ws) {
    let json = {
      type: "statisticDuration",
    };
    let str = JSON.stringify(json);
    // console.log('statisticDuration---统计入库学习时长')
    window.lessonWS.ws.send(str);
  }
}
